module.exports = __webpack_public_path__ + "img/vr.4067e25a.png";